<template>
  <span :class="classes">{{ label }}</span>
</template>

<script>
export default {
  name: 'CourseTypeTag',
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    label() {
      const t = (this.type || '').toString().toLowerCase();
      if (t === 'certification') return 'certificare';
      return this.type || '';
    },
    classes() {
      const base =
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold border  border-gray-500';
      const t = (this.type || '').toString().toLowerCase();
      if (t === 'certification')
        return `${base} text-primary-color bg-gray-300`;
      if (t === 'training') return `${base} text-black bg-gray-300`;
      return `${base} text-white bg-secondary-color`;
    },
  },
};
</script>
